import React from "react";
import { Drawer, DrawerContent, DrawerTrigger } from "../ui/drawer";

import { User } from "../icons";
import LoginStep from "./LoginStep";
import OTPStep from "./OTPStep";
import CompleteProfile from "./completeProfile";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { toggleDrawer } from "@/redux/slices/drawer.slice";
import FinalStep from "./final-step";
import Image from "next/image";
import loginVid from "@/public/videos/login-img.gif";
import { dir } from "i18next";
import { useLocale } from "next-intl";
import useSizes from "@/lib/window-sizes-hook";
import { Dialog, DialogContent, DialogTrigger } from "../ui/dialog";

const Login = () => {
  const { isOpen } = useSelector((state: RootState) => state.drawer);
  const dispatch = useDispatch();
  const locale = useLocale();
  const { maxSm } = useSizes();

  const [activeStep, setActiveStep] = React.useState(0);
  const [mobile, setMobile] = React.useState("");
  const [otp, setOtp] = React.useState("");

  const handleLoginStep = (mobile: string) => {
    setActiveStep((prev) => prev + 1);
    setMobile(mobile);
  };
  const handleOTPStep = (exist: boolean, otp: string) => {
    setActiveStep((prev) => (exist ? 3 : prev + 1));
    setOtp(otp);
  };

  const handleCompleteProfile = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleGoBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const steps = new Map([
    [0, <LoginStep key={"mobile"} onAfterSubmit={handleLoginStep} />],
    [
      1,
      <OTPStep
        key={"otp"}
        onAfterSubmit={handleOTPStep}
        onGoBack={handleGoBack}
        data={{ mobile }}
      />,
    ],
    [
      2,
      <CompleteProfile
        key={"profile"}
        onAfterSubmit={handleCompleteProfile}
        data={{ otp, mobile }}
      />,
    ],
    [3, <FinalStep key={"final"} />],
  ]);

  if (maxSm) {
    return (
      <Dialog
        {...{
          open: isOpen,
          onOpenChange: (isOpen) => dispatch(toggleDrawer({ isOpen })),
        }}
      >
        <DialogTrigger asChild>
          <button
            type="button"
            className="cursor-pointer border p-2 rounded-full border-gray-light hover:border-gray-dark [&>svg>path]:fill-gray-light [&>svg>path]:hover:fill-gray-dark"
          >
            <User className="size-6 " />
          </button>
        </DialogTrigger>
        <DialogContent className="!max-w-5xl w-full max-sm:max-w-full p-0 bg-green-background">
          <div className="overflow-y-auto max-sm:flex-col-reverse gap-3 sm:gap-6 flex justify-center items-center h-full sm:p-4 p-2">
            {activeStep === 3 ? (
              steps.get(activeStep)
            ) : (
              <>
                <div className="max-w-[430px]">{steps.get(activeStep)}</div>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      {...{
        direction: locale === "ar" ? "left" : "right",
        open: isOpen,
        onOpenChange: (isOpen) => dispatch(toggleDrawer({ isOpen })),
      }}
    >
      <DrawerTrigger asChild>
        <button
          type="button"
          aria-label="login button"
          className="cursor-pointer border p-2 rounded-full border-gray-light hover:border-gray-dark [&>svg>path]:fill-gray-light [&>svg>path]:hover:fill-gray-dark"
        >
          <User className="size-6 " />
        </button>
      </DrawerTrigger>
      <DrawerContent
        dir={dir(locale as string)}
        className="!max-w-5xl w-full max-sm:max-w-full p-0"
      >
        <div className="overflow-y-auto max-sm:flex-col-reverse gap-3 sm:gap-6 flex justify-center items-center h-full sm:p-4 p-2">
          {activeStep === 3 ? (
            steps.get(activeStep)
          ) : (
            <>
              <div className="max-w-[430px]">{steps.get(activeStep)}</div>
              <div className="max-w-md">
                <Image src={loginVid} alt="login video" />
              </div>
            </>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default Login;
